import { render, staticRenderFns } from "./SubPanelBra.vue?vue&type=template&id=e8e4ddb2&scoped=true"
import script from "./SubPanelBra.vue?vue&type=script&lang=js"
export * from "./SubPanelBra.vue?vue&type=script&lang=js"
import style0 from "./SubPanelBra.vue?vue&type=style&index=0&id=e8e4ddb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e4ddb2",
  null
  
)

export default component.exports